import { Permissions } from '../permissions';
import { shared } from '@tig-dpqa-cloud/contract-backend-common';
import { z } from 'zod';

export const UserIdSchema = z.uuid();
export const UserPermissionsSchema = z.array(Permissions.exclude([Permissions.enum.DEFAULT]));

export const UserWithPermissions = shared.User.extend({
  permissions: UserPermissionsSchema,
});

export const UserCreationBody = UserWithPermissions.omit({
  id: true,
  tenantId: true,
  firstName: true,
  lastName: true,
}).transform((user) => ({ ...user, email: user.email.toLowerCase() }));

export type UserCreationBodyType = z.infer<typeof UserCreationBody>;

export const UsersGetResponse = z.array(UserWithPermissions);

export type UsersGetResponseType = z.infer<typeof UsersGetResponse>;
export type UsersPostResponseType = z.infer<typeof UserWithPermissions>;
